import {
    ADMIN_LOGIN, ADMIN_LOGOUT, ADMIN_REGISTER, ADMIN_RELOGIN
} from '../../index.types';

export function register(data) {
    return {
        type: ADMIN_REGISTER,
        data
    }
}
export function login(data) {
    return {
        type: ADMIN_LOGIN,
        data,
    };
}

export function logOut(data) {
    return {
        type: ADMIN_LOGOUT,
        data,
    };
}

export function relogin(data = {}) {
    return {
        type: ADMIN_RELOGIN,
        data,
    };
}

